import { compact, uniqBy } from 'lodash';

import { CAPE_OF_GOOD_HOPE_ID, PANAMA_CANAL_ID, SUEZ_CANAL_ID } from '@/lib/constants';
import { RouteViaInterface } from '@/types';
import { RouteLinkSegmentEventApiV4Interface, RouteSequenceApiV4Interface } from '@/types/api-types';

export const getApiOptionNotableVias = (option: RouteSequenceApiV4Interface): RouteViaInterface[] => {
  const { segments } = option;
  const segmentEvents = segments.reduce((accum, segment) => {
    if ('events' in segment && segment.events) {
      const events = segment.events.flat();

      if (events) {
        const filteredEvents = events.filter((e) => e.type === 'waypoint' || e.type === 'canalThru');
        return [...accum, ...filteredEvents];
      }
    }
    return accum;
  }, [] as RouteLinkSegmentEventApiV4Interface[]);

  const segmentEventIds = segmentEvents.map((event) => event.locationId);

  return processViaLocationIds(segmentEventIds);
};

export const processViaLocationIds = (locationIds: string[]): RouteViaInterface[] => {
  const locations = compact(
    locationIds.map((locationId) => {
      switch (locationId) {
        case CAPE_OF_GOOD_HOPE_ID:
          return {
            short: 'via CGH',
            long: 'via Cape of Good Hope (Southern Africa)',
            description: 'This route is scheduled to go via the Cape of Good Hope (Southern Africa).',
            locationId,
          };
        case SUEZ_CANAL_ID:
          return {
            short: 'via Suez',
            long: 'via Suez Canal / Red Sea',
            description: 'This route is scheduled to go via the Suez canal. Delays or diversions are possible.',
            locationId,
          };
        case PANAMA_CANAL_ID:
          return {
            short: 'via Panama',
            long: 'via Panama Canal',
            description: 'This route is scheduled to go via the Panama canal.',
            locationId,
          };
        default:
          return undefined;
      }
    }),
  );

  return uniqBy(locations, 'locationId');
};
